import { useContext } from 'react';
import ReqContext from '../state/ReqContext';

/**
 * The express Req object.
 *
 * This will always be undefined on the client.
 */
const useReq = () => useContext(ReqContext);

export default useReq;
